module.exports = __webpack_public_path__ + "img/next-week-delivery.2f132289.png";